define('mastheadViewModel',['grasshopperModel'], function (GrasshopperModel) {
    'use strict';

    return GrasshopperModel.extend({
        defaults : {}
    });

});

